import axios from 'axios';
import { configRefs } from '@utils/constants';
import '@i-ark/models';
import '@utils/common';
import '@i-ark/constants';
import '@i-ark/utils';
import { transformComponentEntryV1ToV2 } from './v1Adapter/componentEntry/transformComponentEntryV1ToV2.js';

const fetchEntryById = async (component, userId, entryId) => {
  const url = `${await configRefs.apis.userdata.get()}/api/ComponentEntries/${encodeURIComponent(entryId)}`;
  const response = await axios.get(url);
  const rawComponentEntry = typeof response.data.content === "string" && response.data.content.length > 0 ? JSON.parse(response.data.content) : createEmptyEntry();
  const v2ComponentEntry = isComponentEntryV1(rawComponentEntry) ? transformComponentEntryV1ToV2(component, rawComponentEntry) : rawComponentEntry;
  return {
    userId: response.data.userID,
    shared: response.data.shared,
    ...v2ComponentEntry
  };
};
function isComponentEntryV1(componentEntry) {
  return !("version" in componentEntry) || componentEntry.version !== 2;
}
function createEmptyEntry() {
  return {
    version: 2,
    originalVersion: 2,
    pages: [],
    currentPageId: void 0
  };
}

export { fetchEntryById, isComponentEntryV1 };
//# sourceMappingURL=fetchEntryById.js.map
